import {
  IAssessmentQuestionDetail,
  IUpdateAssessmentRequest,
} from "../../../../api/crmContent.service";

/**
 * dbo.AssessmentSharedTypes id for District. Assessments authored in Academics
 * are shared to the district; district access requires IsSharedAssessment = 1
 * and this shared type (PLP-6514).
 */
export const DISTRICT_SHARED_TYPE_ID = 3;

export interface ICreateAssessmentInput {
  userId: number;
  subjectId: string;
  name: string;
  csvFile: File;
}

/** Builds the multipart body for POST cms/assessments. */
export const buildCreateAssessmentFormData = (
  input: ICreateAssessmentInput
): FormData => {
  const formData = new FormData();
  formData.append("userId", String(input.userId));
  formData.append("subjectId", input.subjectId);
  formData.append("name", input.name.trim());
  formData.append("assessmentSharedTypeId", String(DISTRICT_SHARED_TYPE_ID));
  formData.append("csvFile", input.csvFile);
  return formData;
};

/**
 * Builds the PUT cms/assessments/{id} body. The shared type is sent back as it
 * was loaded, so saving never changes the assessment's sharing.
 */
export const buildUpdateAssessmentRequest = (
  name: string,
  subjectId: number,
  sharedTypeId: number | null,
  questions: IAssessmentQuestionDetail[]
): IUpdateAssessmentRequest => ({
  name,
  subjectId,
  assessmentSharedTypeId: sharedTypeId,
  questions: questions.map((q) => ({
    questionId: q.questionId,
    standardId: q.standardId ?? null,
    isTeacherQuestion: q.assessmentQuestionTypeId === 3,
  })),
});
